import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import PopupMenu from '@jetbrains/ring-ui/components/popup-menu/popup-menu'
import type {ReactElement} from 'react'

import {IntegrationType} from '../Integrations.consts'

import styles from './AddIntegration.css'

type Props = {
  onSelectIntegration: (type: IntegrationType) => void
  anchor: ReactElement
}

export function AddIntegration({onSelectIntegration, anchor}: Props) {
  return (
    <Dropdown className={styles.addIntegration} anchor={anchor}>
      <PopupMenu
        className={styles.popupMenu}
        data={[
          {
            label: 'NPM',
            details:
              'Allows Jobs to access a private npm registry during a build (exp. to download a package)',
            onClick: () => onSelectIntegration(IntegrationType.NPM),
          },
          {
            label: 'Docker Repository',
            details: "Securly runs 'Docker login' before your job",
            onClick: () => onSelectIntegration(IntegrationType.DOCKER),
          },
        ]}
        closeOnSelect
      />
    </Dropdown>
  )
}
